module.exports = __webpack_public_path__ + "static/img/logo.c637d1a9.png";